import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "cache-manager",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "cache-manager" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
